const faqData = [
  {
    title: "Quem precisa de psicoterapia?",
    content: [
      "A procura por tratamento psicológico não deve restringir-se apenas a casos emergenciais.",
      "A qualquer momento da vida, em que sintamos necessidade desse suporte, é possível buscar ajuda.",
      "Seja quais forem suas angústias, sinta-se à vontade para conversar comigo.",
    ],
  },
  {
    title: "Um psicólogo resolverá todos meus problemas?",
    content: [
      "Não exatamente.",
      "A função do psicólogo é oferecer um suporte significativo para ajudá-lo a desenvolver ferramentas que o auxiliem no enfrentamento dos seus desafios emocionais e psicológicos.",
      "O profissional incentiva reflexões e confrontos internos para uma melhor compreensão e aceitação de si mesmo.",
    ],
  },
  {
    title: "Um psicólogo revelará meus segredos?",
    content: [
      "Não. Todas as informações compartilhadas durante as sessões de terapia são mantidas em sigilo.",
      "A confidencialidade é um dos princípios éticos fundamentais da profissão.",
      "Cabe ao profissional garantir a privacidade e o sigilo das informações do paciente.",
    ],
  },
  {
    title: "Quanto tempo dura o tratamento?",
    content: [
      "Não existe um prazo pré-determinado.",
      "Cada pessoa tem seu tempo, e a psicoterapia terá a duração que você necessitar.",
    ],
  },
];
export default faqData;
